"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridView = void 0;
const i18n_1 = require("../../exports/i18n");
const constants_1 = require("../../modules/shared/store/constants");
const selectors_1 = require("../../exports/store/selectors");
const datasheet_1 = require("../datasheet");
const views_1 = require("./views");
const config_1 = require("../../config");
const utils_1 = require("../../utils");
class GridView extends views_1.View {
    get recordShowName() {
        return (0, i18n_1.t)(i18n_1.Strings.row);
    }
    get recordShowUnit() {
        return '';
    }
    static generateDefaultProperty(snapshot, activeViewId) {
        const views = snapshot.meta.views;
        let srcView;
        if (activeViewId) {
            srcView = (0, selectors_1.getViewById)(snapshot, activeViewId);
        }
        if (!srcView) {
            srcView = views[0];
        }
        let columns;
        if (srcView) {
            if (srcView.type === constants_1.ViewType.Grid) {
                columns = srcView.columns.map(item => {
                    return { fieldId: item.fieldId, width: item.width };
                });
            }
            else {
                columns = srcView.columns.map(item => {
                    return { fieldId: item.fieldId };
                });
            }
        }
        else {
            throw Error((0, i18n_1.t)(i18n_1.Strings.error_not_found_the_source_of_view));
        }
        return {
            id: datasheet_1.DatasheetActions.getNewViewId(views),
            name: datasheet_1.DatasheetActions.getDefaultViewName(views, constants_1.ViewType.Grid),
            type: constants_1.ViewType.Grid,
            rowHeightLevel: 1,
            columns,
            rows: this.defaultRows(srcView),
            frozenColumnCount: 1,
            displayHiddenColumnWithinMirror: false
        };
    }
    static getViewIntroduce() {
        return {
            title: (0, i18n_1.t)(i18n_1.Strings.grid_view),
            desc: (0, i18n_1.t)(i18n_1.Strings.grid_guide_desc),
            videoGuide: (0, utils_1.integrateCdnHost)(config_1.Settings.view_grid_guide_video.value),
        };
    }
}
exports.GridView = GridView;
//# sourceMappingURL=grid_view.js.map